module.exports = __webpack_public_path__ + "img/hk-active.4c94fb03.png";